module.exports = __webpack_public_path__ + "img/rightArrow.298163cb.svg";